<template>
    <div class="carousel">
        <div class="swiper-container">
            <div class="swiper-wrapper">
                <div class="swiper-slide carouselCom_cont_item" v-for="(item, index) in listData" :key="index">
                    <div>
                        <div class="carouselCom_cont_top">{{ item.contTop }}</div>
                        <div class="carouselCom_cont_mid">{{ item.contMid }}</div>
                        <div class="carouselCom_cont_more" @click="routerPages(index)">
                            了解更多<img src="../assets/home/red_right.png" alt="">
                        </div>
                    </div>
                    <div class="carouselCom_cont_img">
                        <img :style="{ width: item.width, height: item.height }" :src="item.imgUrl" alt="">
                    </div>
                </div>
            </div>
            <!-- 如果需要分页器 -->
            <!-- <div class="swiper-pagination"></div> -->
            <!-- 如果需要导航按钮 -->
            <div class="swiper-button-prev"></div>
            <div class="swiper-button-next"></div>


            <!-- 如果需要滚动条 -->
            <!-- <div class="swiper-scrollbar"></div> -->
        </div>
    </div>
</template>
 
<script>
import Swiper from 'swiper'
import 'swiper/dist/css/swiper.css'
export default {
    data() {
        return {
            // 展示数组
            listDataShow: [
                { contTop: '危废终端设备', contMid: '一物一码，实时上报，全过程危废溯源', imgUrl: require('../assets/home/product_one.png'), width: '372px', height: '218px' },
                { contTop: '精细化管理', contMid: '将实时为企业自动登记所有台帐', imgUrl: require('../assets/home/product_two.png'), width: '232px', height: '240px' },
                { contTop: '危废收集数字化管理系统', contMid: '对接平台，实现产业上下游融合及联通', imgUrl: require('../assets/home/product_three.png'), width: '241px', height: '208px' },
            ],
            //辅助数组
            listData: [
                { contTop: '危废终端设备', contMid: '一物一码，实时上报，全过程危废溯源', imgUrl: require('../assets/home/product_one.png'), width: '372px', height: '240px' },
                { contTop: '精细化管理', contMid: '将实时为企业自动登记所有台帐', imgUrl: require('../assets/home/product_two.png'), width: '232px', height: '240px' },
                { contTop: '危废收集数字化管理系统', contMid: '对接平台，实现产业上下游融合及联通', imgUrl: require('../assets/home/product_three.png'), width: '241px', height: '240px' },
                { contTop: '固体废物全过程智慧化管理平台', contMid: '“产生→收集→贮存→运输→处置”的全生命周期管理', imgUrl: require('../assets/home/product_one.png'), width: '372px', height: '240px' },
            ],
            numIndex: 2,
            flagLeft: true,
            flagRight: false,
        }
    },
    mounted() {
        new Swiper('.swiper-container', {

            loop: true, // 循环模式选项

            // 如果需要分页器
            pagination: {
                el: '.swiper-pagination',
            },
            slidesPerView: 3,
            spaceBetween: 20,
            // slidesOffsetBefore: 100,
            // 如果需要前进后退按钮
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },

            // 如果需要滚动条
            scrollbar: {
                el: '.swiper-scrollbar',
            },
        })
    },
    methods: {
        routerPages(index) {
            if (index == 0) {
                this.$router.push('/wasteTerminal')
            } else if (index == 1) {
                this.$router.push('/intelligent')
            } else if (index == 2) {
                this.$router.push('/digitalize')
            }
        },
        left() {
            if (!this.flagLeft) {
                this.flagRight = false;
                this.listDataShow.unshift(this.listData[this.numIndex - 2]); //前面添加一个
                this.listDataShow.splice(this.listDataShow.length - 1, 1); //后面删除一个，此处的index因为前面添加了一个新数据的缘故，注意看是否为数组的最后一个数据
                this.flagLeft = true;
            }

        },
        right() {
            if (!this.flagRight) {
                this.flagLeft = false;
                this.listDataShow.splice(0, 1); //前面删除一个
                this.listDataShow.push(this.listData[3]); //后面添加一个
                this.flagRight = true;
            }

        },

    }
}
</script>
 
<style lang="less" scoped>
.carousel {
    position: relative;
    width: 100%;
}

.carouselCom_cont_item {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    padding: 61px 0 17px 0;
    box-sizing: border-box;
    width: 32%;
    background-color: #fff;

    .carouselCom_cont_top {
        text-align: center;
        font-size: 27px;
        font-weight: bold;
        color: #333333;
    }

    .carouselCom_cont_mid {
        text-align: center;
        font-size: 15px;
        color: #868686;
        margin: 18px 0 30px 0;
    }

    .carouselCom_cont_more {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        color: #333333;
        margin-bottom: 30px;
        cursor: pointer;

        img {
            width: 17px;
            height: 17px;
            margin-left: 23px;
        }
    }
}
</style>
<style>
.swiper-container {
    position: initial;
    width: 90%;
}



.swiper-button-prev {
    background-image: url('../assets/home/product_left.png');
    width: 43px;
    height: 43px;
    background-size: 100% 100%;
    /* 负的 z-index 值 */
}

.swiper-button-next {

    background-image: url('../assets/home/product_right.png');
    width: 43px;
    height: 43px;
    background-size: 100% 100%;
}
</style>